var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63.4 63.4",
    style: {
      enableBackground: "new 0 0 63.4 63.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#595B5C;}\r\n\t.st1{fill:#BAB9B7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 31.7,
    cy: 31.7,
    r: 31.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.7,
    cy: 31.7,
    r: 24.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,26c-0.7-0.6-1.4-1.2-2.1-1.7c-4-2.7-8.4-3.9-13.2-3.7c-2,0.1-4,0.5-5.9,1.2c-0.7-0.8-1.4-1.6-2.2-2.3 c-0.6-0.6-1.4-0.6-2,0c-0.6,0.5-0.6,1.4-0.1,2c0.1,0.2,0.3,0.3,0.4,0.5c5.4,5.8,10.8,11.5,16.2,17.3c1.3,1.4,2.6,2.8,3.9,4.2 c0.7,0.7,1.7,0.7,2.3,0c0.5-0.6,0.5-1.4-0.2-2.1c-3.5-3.7-6.9-7.4-10.4-11.2c-0.1-0.1-0.2-0.2-0.2-0.3c0.7,0,1.3,0.1,1.9,0.2 c2.6,0.5,4.7,1.7,6.6,3.6c0.6,0.7,1.5,0.7,2.1,0.1c0.6-0.6,0.6-1.5-0.1-2.2c-0.9-0.8-1.8-1.6-2.8-2.3c-2.1-1.4-4.5-2.2-7-2.4 c-1-0.1-2,0-3.1,0.1c-0.2,0-0.4,0-0.6-0.2c-0.5-0.6-1.1-1.2-1.6-1.8c-0.3-0.3-0.6-0.6-0.9-1c2.7-0.8,5.5-0.9,8.2-0.4 c3,0.6,5.6,1.8,8,3.7c0.3,0.2,0.6,0.5,0.9,0.8c0.6,0.5,1.5,0.4,2-0.3C46.6,27.4,46.5,26.5,45.9,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.8,35.2c-0.1-0.6-0.5-1.1-1.1-1.3c-0.5-0.1-0.9,0-1.3,0.2c-1.3,0.6-2.4,1.5-3.4,2.6c-0.4,0.4-0.4,1-0.2,1.5 c0.3,0.5,0.7,0.8,1.3,0.9c0.5,0,0.8-0.2,1.1-0.5c0.8-0.8,1.6-1.5,2.6-1.9C30.5,36.4,30.9,35.8,30.8,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.4,30.7c0-1.4-1.1-2.1-2.1-1.5c-1.3,0.7-2.4,1.6-3.4,2.6c-0.6,0.6-0.5,1.5,0,2c0.6,0.6,1.5,0.6,2,0 c0.9-0.8,1.8-1.6,2.8-2.2C26.2,31.4,26.4,31,26.4,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22,25.1c-0.4-0.8-1.3-1-2.1-0.6c-0.9,0.5-1.7,1.2-2.5,1.9c-0.5,0.4-0.5,1-0.3,1.6c0.2,0.6,0.7,0.9,1.4,0.9 c0.4,0,0.8-0.2,1.1-0.5c0.6-0.5,1.1-0.9,1.8-1.3C22.1,26.6,22.4,25.8,22,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.7,40.4c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.9c1,0,1.8-0.8,1.9-1.8C33.6,41.3,32.7,40.4,31.7,40.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.3e41186ab48a533fe77e2c803fd1a951.svg";
export { ForwardRef as ReactComponent };